import '../sass/index.scss';
var $ = require('jquery');
// d3 library and adjacent libraries
import * as d3 from 'd3';
import { swoopyDrag } from 'd3-swoopy-drag';
d3.swoopyDrag = swoopyDrag;
// wordwrap uses require() syntax and side-effects
require('./lib/d3-wordwrap');

// import data and label information
import { data } from './data.js';
import { annotations } from './annotations.js';





$( document ).ready(function() {

	var windowWidth = $(document).innerWidth(),
		windowHeight = $(document).innerHeight();

	// mobile view custom sizes
 	var rect_width,
			chart_left_margin;
	if (windowWidth > 400){
		chart_left_margin = 90;
	} else{
		chart_left_margin =30;
	};

	// variables global to app
	var margin = {
			top:10,
			right:30,
			bottom:30,
			left: chart_left_margin
		},
	width = $('#viz-container').width()-margin.left-margin.right,
	height = 2300,
	visContainer = $('#viz-container').width();
	svg;

	//append g
	var svg = d3.select('#viz-container')
			.append('svg')
				.attr('width',width+margin.left+margin.right)
				.attr('height',height+margin.top+margin.bottom)
				.attr('class', "svg")
			.append('g')
				.attr('transform','translate(' + margin.left + ',' + margin.top + ')');

	//Create scale functions
	var xScale = d3.scaleLinear()
						.domain([0,2000000])
						//.tickValues([0,50,100,150,200])
						.range([margin.left, width-margin.right]);


	var yScale = d3.scaleLinear()
						 .domain([-10,2300])
						 .range([0,height - margin.top]);

	// define your axes
	var xAxis = d3.axisBottom(xScale);
  var xAxisTop = d3.axisTop(xScale);

	var yAxis = d3.axisLeft(yScale);

  xAxis.tickFormat(function(d, i){
          if (d == 0){
            return 0
          } else if (d < 999999 && d > 0){
            return '$'+ thousands(d)
          } else if( d > 999999){
            return  '$' + d/1000000 + ' million';
          }

				})
				.tickValues([0, 1000000, 2000000])
        .tickSize(0)
        // .tickSize(height - margin.top - margin.bottom);

    xAxisTop.tickFormat(function(d, i){
            if (d == 0){
              return 0
            } else if (d < 999999 && d > 0){
              return '$'+ thousands(d)
            } else if( d > 999999){
              return  '$' + d/1000000 + ' million';
            }

  				})
  				.tickValues([0,  1000000, 2000000])
          .tickSize( -height + margin.top );


	yAxis.tickFormat(function(d, i){
        if (d == 0){return 'June 2008'}
        else if (d == 205){return 'Jan. 2009'}
        else if (d == 386){ return 'July 2009'}
        else if (d == 570){ return 'Jan. 2010'}
        else if (d == 751){ return 'July 2010'}
        else if (d == 935){ return 'Jan. 2011'}
        else if (d == 1116){ return 'July 2011'}
        else if (d == 1300){ return 'Jan. 2012'}
        else if (d == 1482){ return 'July 2012'}
        else if (d == 1666){ return 'Jan. 2013'}
        else if (d == 1847){ return 'July 2013'}
        else if (d == 2031){ return 'Jan. 2014'}
        else if (d == 2212){ return 'July 2014'}


				})
				.tickValues([0, 205, 386, 570, 751, 935, 1116, 1300, 1482, 1666, 1847, 2031, 2212])
				.tickSize(width-margin.right);


	var thousands = d3.format(",");


	var swoopy = d3.swoopyDrag()
		    .x(function(d){ return xScale(d.xVal) })
		    .y(function(d){ return yScale(d.yVal) })
		    .draggable(false)
		    .annotations(annotations)


	// for tooltip
	var tooltip = d3.select("body")
		.append("div")
		.attr("class", "tooltip tooltip-noarrow");


	function makeScatterplot (){

		 // Add the top X Axis
			  svg.append("g")
			  		.attr("class", "x axis")
		      	.attr("transform", "translate(0,"+ (margin.top) + ")")
		      	.call(xAxisTop);

    // Add the bottom X Axis
			  svg.append("g")
			  		.attr("class", "x axis")
			      	.attr("transform", "translate(0," + (height - margin.top) + ")")
			      	.call(xAxis);

			  // Add the Y Axis
			  svg.append("g")
			  		.attr("class", "y axis")
			  		.attr("transform", "translate(" + (width) + ",0)")
			      	.call(yAxis);


		// make circles
		svg.selectAll("circle")
		   .data(data)
		   .enter()
			   .append("circle")
			   .on("mouseover", function(d) {
					var tooltip = d3.select("body")
						.append("div")
						.attr("class", "tooltip");
		      		tooltip.html('<div class="legend">'+
								'<p style="padding:10px"><strong>'+d.kind_of_vendor+'</strong></p>'+
		      			'<table style="width:100%;">'+

                '<tr></td><td>Paid to:</td><td style="text-align:right"> '+ d.kind_of_vendor +'</td></tr>'+
								'<tr><td>Amount paid:</td</td><td style="text-align:right"> $'+ thousands(d.transaction) +'</td></tr>'+
                '<tr><td>Paid via:</td</td><td style="text-align:right">'+ d.holder +'</td></tr>'+
                '<tr><td>Paying entity based in:</td</td><td style="text-align:right">'+ d.origination +'</td></tr>'+

                '</table></div>')
		            tooltip.style("opacity", 1)
		                .style("position", "absolute");
		            if (d3.event.pageX > (width/2)){
		        		tooltip.style("left", (d3.event.pageX)-200 + "px")
		        			.style("top", (d3.event.pageY) + "px")
		        			.append("rect");
		            }else{
		            	tooltip.style("left", (d3.event.pageX)+ "px")
	        					.style("top", (d3.event.pageY) + "px")

		            }

				})
				.on("mouseout", function(d) {

					d3.selectAll('.tooltip').remove();

				})
			   .attr("cx", function(d) {
			   		return 0;

			   })
			   .attr("class", function(d){
			   	return d.category + " circle"
			   })
         .attr("cy", function(d) {
             return yScale(d.days_elapsed);
          })
			    .attr("r", 0)
				   	.transition()
				   	.duration(function(d,i){
							 return 100 + (i*25) ;
						})
            .attr("cx", function(d) {
               return xScale(d.transaction);

            })
				.attr("r", function(d) {
					return Math.sqrt((d.transaction/100)/Math.PI);

			   })

		 	   .attr("opacity",  function(d){
		 	   		return 0.75
				});






		    // make labels
				var swoopySel = svg.append('g')
														.call(swoopy);


				// text wrap my labels, assign classes
				swoopySel.selectAll('text')
						.each(function(d){
							d3.select(this)
										.attr("class", function(d,i){
											return "swoopy-drag-lines " + d.label_name;
										})
									.text('')                        //clear existing text
									.tspans(d3.wordwrap(d.text, 24)) //wrap after 20 char
						});



					// assign classes to paths
					swoopySel.selectAll('path')
							.each(function(d){
								d3.select(this)
											.attr("class", function(d,i){
												return "swoopy-drag-lines " + d.label_name;
											})

					});








	}


	makeScatterplot();






});



// WEBPACK FOOTER //
// js/index.js